import {
  ActionIcon,
  Badge,
  Button,
  Modal,
  Pagination,
  Select,
  Table,
  Text,
  TextInput,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { getComplianceStatus, getDeptUsers } from "../apis/userApis";
import BusinessUnitName from "../componenets/getBuName";
import {
  getDepartmentText,
  getComplianceBadgeColor,
  infoColor,
  getDateStatus,
  getStatusColor,
  getStatusText,
  csvDownload,
  excelDownload,
} from "./utilities";
import {
  IconEye,
  IconHistory,
  IconRefresh,
  IconSortAscending,
  IconSortDescending,
} from "@tabler/icons-react";
import DoughnutChart from "../componenets/DoughnutChart";
import DoughnutChart3 from "../componenets/DoughnutChart3";
import DoughnutChart2 from "../componenets/DoughnutChart2";
import DoughnutChart4 from "../componenets/DoughnutChart4";
import { useNavigate } from "react-router-dom";
import ObligationTranHistoryModal from "./ObligationTranHistoryModal";
import { IconInfoCircle } from "@tabler/icons-react";
import DoughnutChart5 from "../componenets/DoughnutChart5";
import { getCookiesSession } from "../apis/cookiesSession";

const DashboardCompliance = () => {
  const userData = JSON.parse(getCookiesSession("userData"));
  const [uiConfig, setUiConfig] = useState({
    obligations: null,
    loading: true,
  });
  const [countConfig, setCountConifg] = useState({
    page: 1,
    count: 0,
    pageSize: 10,
  });
  const [filtersForData, setFiltersForData] = useState({
    compliant: null,
    department:
      userData.loginAs === "Ob-CXO" || userData.loginAs === "Ob-DeptAdmin"
        ? userData.activeDepartment
        : null,
    businessUnit: userData.loginAs === "Ob-COO" ? userData.businessUnit : null,
    extraCol1: null,
    mapRegion: null,
    assignToId: null,

  });
  const [csvData, setCsvData] = useState([]);
  const [compliantData, setCompliantData] = useState(null);
  const [businessUnitData, setBusinessUnitData] = useState(null);
  const [departmentData, setDepartmentData] = useState(null);
  const [agreementData, setAgreementData] = useState(null);
  const [regionData, setRegionData] = useState(null);
  const [assignedToData, setAssignedToData] = useState(null);
  const [ahModal, setAhModal] = useState(false);
  const [partyNames, setPartyNames] = useState([]);
  const [ahId, setAhId] = useState(0);
  const navigate = useNavigate();
  const [sortByOptions, setSortByOptions] = useState({
    key: "duedate",
    value: "asc",
  });
  const handleKeyChange = (val) => {
    const newSortOption = { key: val, value: sortByOptions.value };
    setSortByOptions(newSortOption);
  };
  const toggleOrder = () => {
    const newSortOption = {
      key: sortByOptions.key,
      value: sortByOptions.value === "asc" ? "desc" : "asc",
    };
    setSortByOptions(newSortOption);
  };

  useEffect(() => {
    const getData = async () => {
      const filterdata = Object.fromEntries(
        Object.entries(filtersForData).filter(([key, value]) => value !== null)
      );
      const response = await getComplianceStatus({
        sortOptions: sortByOptions,
        filters: filterdata,
        page: countConfig.page,
        pageSize: countConfig.pageSize,
      });
      console.log(response);
      setUiConfig({
        loading: false,
        obligations: response.obligations,
      });
      setCountConifg({
        ...countConfig,
        count: response.count,
      });
      setCompliantData(response.compliantStatusCount);
      setBusinessUnitData(response.businessUnitCount);
      setDepartmentData(response.departmentCount);
      setAgreementData(response.agreementCount);
      setRegionData(response.regionCount);
      setCsvData(response.exportData);
      setAssignedToData(response.assignToCount);
      setPartyNames(response.parties);
    };
    getData();
  }, [countConfig.page, filtersForData, countConfig.pageSize, sortByOptions]);
  let sr = (countConfig.page - 1) * countConfig.pageSize + 1;
  const onViewClick = (id) => {
    window.open(`/viewobligation/${id}`, "_blank");
  };

  const onExport = async () => {
    if (csvData.length > 0) {
      const columnHeaders = Object.keys(csvData[0]);
      excelDownload({
        data: csvData,
        headers: columnHeaders,
        name: "dashboard_obligations",
      });
    }
  };
  const [expandedId, setExpandedId] = useState(null); // Tracks the currently expanded obligation by ID
  const [assignToData, setAssignToData] = useState([
    { label: "assigned to", value: null },
  ]);
  const handleExpand = (id) => {
    setExpandedId(id); // Set the ID of the obligation to expand
  };
  useEffect(() => {
    const getassignToUsers = async () => {
      const response = await getDeptUsers();

      setAssignToData(response.userData);
    };
    getassignToUsers();
  }, []);
  return (
    <>
      <div className="m-4">
        <div className="mb-6 flex justify-between">
          <Text className=" text-3xl font-semibold">compliance status</Text>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {compliantData !== null && (
            <div className="chart-container">
              <Text className="font-medium block text-center">compliance</Text>
              <div className="flex justify-center p-4">
                <DoughnutChart
                  compliantData={compliantData}
                  filtersForData={filtersForData}
                  setFiltersForData={setFiltersForData}
                  labels={compliantData.map(
                    (item) => `${item.compliant}/${item._count.id}`
                  )}
                  datafor={compliantData.map((item) => item._count.id)}
                />
              </div>
            </div>
          )}
          {!filtersForData.businessUnit && businessUnitData !== null && (
            <div className="chart-container">
              <Text className="font-medium block text-center">
                business unit
              </Text>
              <div className="flex justify-center p-4">
                <DoughnutChart2
                  businessUnitData={businessUnitData}
                  filtersForData={filtersForData}
                  setFiltersForData={setFiltersForData}
                  labels={businessUnitData.map(
                    (item) => `${item.name}/${item._count.id}`
                  )}
                  datafor={businessUnitData.map((item) => item._count.id)}
                />
              </div>
            </div>
          )}
          {filtersForData.businessUnit && regionData !== null && (
            <div className="chart-container">
              <Text className="font-medium block text-center">
                business regions
              </Text>
              <div className="flex justify-center p-4">
                <DoughnutChart5
                  businessUnitData={regionData}
                  filtersForData={filtersForData}
                  setFiltersForData={setFiltersForData}
                  labels={regionData.map(
                    (item) => `${item.name}/${item._count.id}`
                  )}
                  datafor={regionData.map((item) => item._count.id)}
                />
              </div>
            </div>
          )}
          {departmentData !== null && !filtersForData.department && (
            <div className="chart-container">
              <Text className="font-medium block text-center">department</Text>
              <div className="flex justify-center p-4">
                <DoughnutChart3
                  departmentData={departmentData}
                  filtersForData={filtersForData}
                  setFiltersForData={setFiltersForData}
                  labels={departmentData.map(
                    (item) =>
                      `${getDepartmentText(item.department)}/${item._count.id}`
                  )}
                  datafor={departmentData.map((item) => item._count.id)}
                />
              </div>
            </div>
          )}
          {assignedToData !== null && filtersForData.department && (
            <div className="chart-container">
              <Text className="font-medium block text-center">assigned to</Text>
              <div className="flex justify-center p-4">
                <DoughnutChart3
                  departmentData={assignedToData}
                  filtersForData={null}
                  setFiltersForData={setFiltersForData}
                  labels={assignedToData.map(
                    (item) => `${item.assignedTo}/${item._count.id}`
                  )}
                  datafor={assignedToData.map((item) => item._count.id)}
                />
              </div>
            </div>
          )}
          {agreementData !== null && (
            <div className="chart-container">
              <Text className="font-medium block text-center">
                connected agreement
              </Text>
              <div className="flex justify-center p-4">
                <DoughnutChart4
                  agreementData={agreementData}
                  filtersForData={filtersForData}
                  setFiltersForData={setFiltersForData}
                  labels={agreementData.map(
                    (item) => `${item.extraCol1 + ""}/${item._count.id}`
                  )}
                  datafor={agreementData.map((item) => item._count.id)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="flex justify-end">
        <div className="flex justify-center">
          <div className="flex">
            <Select
              value={sortByOptions.key}
              onChange={(val) => handleKeyChange(val)}
              data={[
                { label: "start date", value: "startDate" },
                { label: "due date", value: "duedate" },
                { label: "second party", value: "connectedParty" },
                { label: "id", value: "id" },
                { label: "brand name", value: "brandName" },
                { label: "title", value: "title" },
              ]}
            />

            <ActionIcon className="mx-2" onClick={toggleOrder}>
              {sortByOptions.value === "asc" ? (
                <IconSortAscending size={32} />
              ) : (
                <IconSortDescending size={32} />
              )}
            </ActionIcon>
          </div>
          <ActionIcon
            className="my-auto"
            onClick={() => window.location.reload()}
          >
            <IconRefresh size={30} />
          </ActionIcon>
          <Button
            className="ml-4 text-center btn p-2"
            style={{ backgroundColor: "#46bde1" }}
            onClick={onExport}
          >
            export
          </Button>
        </div>
      </div>
      {uiConfig.obligations !== null && (
        <>
          <Table striped>
            <thead className="text-center">
              <tr>
                <th style={{ textAlign: "center" }}>sr. no.</th>
                <th style={{ textAlign: "center" }}>title</th>
                <th style={{ textAlign: "center" }}>obligation</th>

                <th style={{ textAlign: "center" }}>
                  <Select
                  style={{maxWidth: "250px"}}
                data={[]}
                creatable
                searchable
                onCreate={(query)=>{
                  setFiltersForData({
                    ...filtersForData,
                    joOrder: {contains: query},
                  })
                }}
                getCreateLabel={(query) => `search "${query}"`}
                placeholder="job order" 
                /></th>
                {/* <th style={{ textAlign: "center" }}>job order</th> */}
                <th style={{ textAlign: "center" }}>
                  <Select
                    searchable
                    data={partyNames}
                    placeholder="second party"
                    onChange={(val) => {
                      setFiltersForData({
                        ...filtersForData,
                        OR: [{ brandName: val }, { connectedParty: val }],
                      });
                    }}
                  />
                </th>
                <th style={{ textAlign: "center" }}>department</th>
                <th style={{ textAlign: "center" }}>
                  <Select
                    width={"100px"}
                    styles={{
                      width: "120px",
                      placeholder: {
                        fontSize: "10px", // Customize placeholder size
                        color: "#999", // Optional: Change placeholder color
                      },
                    }}
                    onChange={(val) =>
                      setFiltersForData({ ...filtersForData, assignToId: val })
                    }
                    placeholder="assigned to"
                    data={assignToData}
                  />
                </th>
                <th style={{ textAlign: "center" }}>compliance</th>
                <th style={{ textAlign: "center" }}>
                  <Select
                    data={[
                      { label: "upcoming", value: 0 },
                      { label: "due", value: 1 },
                      { label: "overdue", value: 2 },
                    ]}
                    styles={{
                      width: "120px",
                      placeholder: {
                        fontSize: "10px", // Customize placeholder size
                        color: "#999", // Optional: Change placeholder color
                      },
                    }}
                    placeholder="status"
                    onChange={(val) => {
                      if (val === 0) {
                        setFiltersForData({
                          ...filtersForData,
                          reminderDate: {
                            gt: new Date(), // new Date() < reminderDate
                          },
                        });
                      } else if (val === 1) {
                        setFiltersForData({
                          ...filtersForData,
                          duedate: {
                            gt: new Date(), // dueDate > new Date()
                          },
                          reminderDate: {
                            lt: new Date(), // new Date() > reminderDate
                          },
                        });
                      } else if (val === 2) {
                        setFiltersForData({
                          ...filtersForData,
                          duedate: {
                            lt: new Date(), // new Date() > dueDate
                          },
                        });
                      }
                    }}
                  />
                </th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              {uiConfig.obligations.map((obligation) => (
                <tr key={obligation.id} style={{ textAlign: "center" }}>
                  <td>{sr++}</td>
                  <td>{obligation.title}</td>
                  <td style={{ textAlign: "center" }}>
                    {expandedId === obligation.id
                      ? obligation.desc // Show full description if expanded
                      : obligation.desc.slice(0, 50)}
                    {/* Truncated description */}
                    {expandedId !== obligation.id &&
                      obligation.desc.length > 50 && (
                        <span
                          onClick={() => handleExpand(obligation.id)}
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          ...
                        </span>
                      )}
                  </td>
                  {/* <td>{obligation.extraCol1}</td> */}
                  <td>{obligation.joOrder}</td>
                  {/* <td>{obligation.joOrder}</td> */}
                  <td>
                    <Text>{obligation.brandName}</Text>
                    <Text>{"(" + obligation.connectedParty + ")"}</Text>
                  </td>
                  <td>{getDepartmentText(obligation.department)}</td>
                  <td>{obligation?.assignTo?.name}</td>
                  <td>
                    <Badge
                      variant="light"
                      color={getComplianceBadgeColor(obligation.compliant)}
                    >
                      {obligation.compliant}
                    </Badge>
                  </td>
                  <td>
                    <Badge
                      variant="light"
                      color={getStatusColor(
                        getDateStatus(
                          obligation.createdAt,
                          obligation.duedate,
                          obligation.reminderTime
                        )
                      )}
                    >
                      {getStatusText(
                        getDateStatus(
                          obligation.createdAt,
                          obligation.duedate,
                          obligation.reminderTime
                        )
                      )}
                    </Badge>
                  </td>
                  <td>
                    <div className="flex flex-row mr-4">
                      <ActionIcon
                        onClick={() => {
                          onViewClick(obligation.id);
                        }}
                        color="white"
                      >
                        <IconEye size={24} />
                      </ActionIcon>
                      {/* )} */}
                    </div>
                  </td>
                  <td>
                    <div className="flex flex-row mr-4">
                      <ActionIcon
                        onClick={() => {
                          setAhId(obligation.id);
                          setAhModal(true);
                        }}
                        color="white"
                      >
                        <IconHistory size={24} />
                      </ActionIcon>

                      {/* )} */}
                    </div>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <div className="flex flex-row mr-4">
                      {obligation.extraCol3 !== "" && (
                        <ActionIcon color="white">
                          <IconInfoCircle
                            color={infoColor(obligation.extraCol3)}
                            size={24}
                          />
                        </ActionIcon>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="flex flex-row justify-center my-4 gap-4">
            <Pagination
              page={countConfig.page}
              onChange={(val) => setCountConifg({ ...countConfig, page: val })}
              total={Math.ceil(countConfig.count / countConfig.pageSize)}
            />
            <Select
              style={{ width: "70px" }}
              value={countConfig.pageSize + ""}
              data={["10", "20", "50"]}
              onChange={(val) =>
                setCountConifg({ ...countConfig, pageSize: parseInt(val) })
              }
            />
          </div>
        </>
      )}
      <Modal
        opened={ahModal}
        onClose={() => {
          setAhModal(false);
          setAhId(0);
        }}
        title="oblligation action history"
        size="calc(80vw)"
      >
        <ObligationTranHistoryModal id={ahId} />
      </Modal>
    </>
  );
};

export default DashboardCompliance;
